'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_pages_AppPage$AdminGeneralPracticesList(cursor) {
  this.Lapp_pages_AppPage$AdminGeneralPracticesList__f_cursor = null;
  this.Lapp_pages_AppPage$AdminGeneralPracticesList__f_cursor = cursor;
}
export { $c_Lapp_pages_AppPage$AdminGeneralPracticesList as $c_Lapp_pages_AppPage$AdminGeneralPracticesList };
$c_Lapp_pages_AppPage$AdminGeneralPracticesList.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_pages_AppPage$AdminGeneralPracticesList.prototype.constructor = $c_Lapp_pages_AppPage$AdminGeneralPracticesList;
/** @constructor */
function $h_Lapp_pages_AppPage$AdminGeneralPracticesList() {
}
export { $h_Lapp_pages_AppPage$AdminGeneralPracticesList as $h_Lapp_pages_AppPage$AdminGeneralPracticesList };
$h_Lapp_pages_AppPage$AdminGeneralPracticesList.prototype = $c_Lapp_pages_AppPage$AdminGeneralPracticesList.prototype;
$c_Lapp_pages_AppPage$AdminGeneralPracticesList.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_pages_AppPage$AdminGeneralPracticesList.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1922263423), true);
});
$c_Lapp_pages_AppPage$AdminGeneralPracticesList.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_pages_AppPage$AdminGeneralPracticesList)) {
    var x = this.Lapp_pages_AppPage$AdminGeneralPracticesList__f_cursor;
    var x$2 = x$0.Lapp_pages_AppPage$AdminGeneralPracticesList__f_cursor;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lapp_pages_AppPage$AdminGeneralPracticesList.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_pages_AppPage$AdminGeneralPracticesList.prototype.productArity__I = (function() {
  return 1;
});
$c_Lapp_pages_AppPage$AdminGeneralPracticesList.prototype.productPrefix__T = (function() {
  return "AdminGeneralPracticesList";
});
$c_Lapp_pages_AppPage$AdminGeneralPracticesList.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_pages_AppPage$AdminGeneralPracticesList__f_cursor;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_pages_AppPage$AdminGeneralPracticesList.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "cursor";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_pages_AppPage$AdminGeneralPracticesList(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_pages_AppPage$AdminGeneralPracticesList)));
}
export { $isArrayOf_Lapp_pages_AppPage$AdminGeneralPracticesList as $isArrayOf_Lapp_pages_AppPage$AdminGeneralPracticesList };
var $d_Lapp_pages_AppPage$AdminGeneralPracticesList = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_pages_AppPage$AdminGeneralPracticesList, "app.pages.AppPage$AdminGeneralPracticesList", ({
  Lapp_pages_AppPage$AdminGeneralPracticesList: 1,
  Lapp_pages_AppPage: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_pages_AppPage$AdminGeneralPracticesList as $d_Lapp_pages_AppPage$AdminGeneralPracticesList };
//# sourceMappingURL=app.pages.-App-Page$-Admin-General-Practices-List.js.map
